<template>
  <select class="form-control m-input" @select="emitChangeEvent" @change="emitChangeEvent">
    <option v-if="firstOption" value="">{{ firstOption }}</option>
    <option
      v-for="bank in selects"
      :key="bank.id"
      :value="bank.id"
      :selected="bank.id == selected"
      >{{ bank.name }}</option
    >
  </select>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'SelectBillingBanks',
  data() {
    return {
      selects: [],
      firstOption: this.first ? this.first : null,
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
  },
  methods: {
    getData() {
      axios(`${baseApiUrl}/v1/billing-banks/all`).then(
        (res) => (this.selects = res.data.data)
      );
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
